/** Endereços da área de administração (montada em `admin/*` por `app/routes.tsx`). */
export const ADMIN_PATH = '/admin';
export const USERS_PATH = `${ADMIN_PATH}/usuarios`;
export const WHATSAPP_PATH = `${ADMIN_PATH}/whatsapp`;
export const BITRIX_PATH = `${ADMIN_PATH}/bitrix`;
export const QUICK_REPLIES_PATH = `${ADMIN_PATH}/respostas-rapidas`;
/** A caixa de entrada: destino de "Voltar" e de "Ir para a caixa de entrada". */
export const INBOX_PATH = '/';

/** `/admin` (ou `/admin/`): só redireciona para a primeira seção. */
export const isAdminRoot = (pathname: string): boolean =>
  pathname === ADMIN_PATH || pathname === `${ADMIN_PATH}/`;
